// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
// @end

export interface IContactEmailParams {
  nameFrom: string
  lastNameFrom: string
  country: string
  city: string
  phoneNumber: string
  emailFrom: string
  message: string
}

class ContactService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  sendEmail = async (data: IContactEmailParams) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/contact/send-email`,
      auth_token: this.token,
      params: {...data}
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }
}

export default ContactService
